module.exports = __webpack_public_path__ + "static/media/LI-Mobile-background.14d76ada.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/LI-Mobile-background.jpg
// module id = 452
// module chunks = 0